import { clientSlice } from "./slice/clientSlice";
import { navigationSlice } from "./slice/navigationSlice";
import { bugSlice } from "./slice/bugSlice";
import {setupSlice} from "./slice/setupSlice";
import { dashboardSlice } from "./slice/dashboardSlice";
import { configureStore } from '@reduxjs/toolkit';
import { loadingSlice } from "./slice/loadingSlice";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from 'redux';

// Configure persist for client details to save projects
const clientPersistConfig = {
    key: 'clientDetails',
    storage,
    whitelist: ['selectedClient', 'selectedClientProjects'] // only these will be persisted
};

const rootReducer = combineReducers({
    clientDetails: persistReducer(clientPersistConfig, clientSlice.reducer),
    bugDetails: bugSlice.reducer,
    navigation: navigationSlice.reducer,
    setupDetails: setupSlice.reducer,
    dashboardDetails: dashboardSlice.reducer,
    loadingDetails: loadingSlice.reducer
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // to avoid non-serializable value error with redux-persist
        }),
});

const persistor = persistStore(store);

export { store, persistor };